// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__oXz22","info":"UpdateTermsInfo_info__2qx5Q"};